module.exports = __webpack_public_path__ + "img/page-17.3d8c55b0.jpg";